
import React, { useContext ,useEffect} from 'react'
import { AppContext } from '../../../provider'
export const ServiceDetails = ({ selectedOption }) => {
     const { setPageIndex } = useContext(AppContext);

     useEffect(() => {
             window.scrollTo({ top: 0, behavior: "smooth" });
         }, []);
    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', margin: '30px 50px 17px 42px', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div onClick={() => {setPageIndex(0) }} className='submit-button-variable' style={{ marginRight: '30px' }}>
                        <span>🡐 back</span>
                    </div>
                    <p className='title-demo' style={{ margin: '0',fontSize:'20px' }}>{selectedOption}</p>
                </div>
            </div>
        </div>
    )
}

